import { useQuery } from "@tanstack/react-query"
import { api } from "@/services/api"

export default function useGetCosmos(params: Parameters<typeof api.cronos.cosmos.get>[0]) {
  const query = useQuery({
    queryKey: ["get-cosmos", params],
    queryFn: () => api.cronos.cosmos.get(params),
    enabled: false,
  })

  return query
}
